import React from "react";

interface KxdDataExplorationIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const KxdDataExplorationIcon: React.FC<KxdDataExplorationIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M18.3333 0C18.7754 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22464 20 1.66667V18.3333C20 18.7754 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.7754 20 18.3333 20H1.66667C1.22464 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.7754 0 18.3333V1.66667C0 1.22464 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22464 0 1.66667 0H18.3333ZM4.44444 8.33333V13.8889C4.44445 14.0362 4.50302 14.1775 4.6072 14.2817C4.71139 14.3859 4.85266 14.4444 5 14.4444H7.22222V8.33333H4.44444ZM8.33333 8.33333V14.4444H11.6667V8.33333H8.33333ZM12.7778 8.33333V14.4444H15C15.1473 14.4444 15.2886 14.3859 15.3928 14.2817C15.497 14.1775 15.5556 14.0362 15.5556 13.8889V8.33333H12.7778ZM5 4.44444C4.85266 4.44444 4.71139 4.50302 4.6072 4.6072C4.50302 4.71139 4.44444 4.85266 4.44444 5V7.22222H15.5556V5C15.5556 4.85266 15.497 4.71139 15.3928 4.6072C15.2886 4.50302 15.1473 4.44445 15 4.44444H5Z" fill="#002366"/>
    </svg>
  );
};

export default KxdDataExplorationIcon;
